export default __webpack_public_path__ + "static/media/image-icon.ebab837b.svg";